import { useEffect, useState } from "react";
import { Inbox } from "lucide-react";
import { api } from "@/pages/Admin";

const typeLabels = { production: "Production deal", visibility: "Platform visibility", both: "Production + visibility" };

export const Submissions = () => {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/contact").then((r) => setItems(r.data)).finally(() => setLoaded(true));
  }, []);

  if (loaded && items.length === 0) {
    return (
      <div className="flex flex-col items-center gap-3 py-20 text-slate-500">
        <Inbox size={32} strokeWidth={1.5} />
        <p className="font-mono-tech text-xs tracking-[0.25em] uppercase">No artist submissions yet</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <h2 className="font-display text-lg font-bold text-white uppercase">Artist Submissions ({items.length})</h2>
      <div className="space-y-px">
        {items.map((s) => (
          <div key={s.id} data-testid={`submission-${s.id}`} className="bg-[#0c0c12] border border-white/10 p-5">
            <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mb-2">
              <span className="font-display text-sm font-bold text-white uppercase">{s.artist_name}</span>
              <a href={`mailto:${s.email}`} className="font-mono-tech text-[11px] text-[#00f0ff] hover:underline">{s.email}</a>
              <span className="font-mono-tech text-[10px] tracking-[0.2em] uppercase px-2 py-0.5 border border-[#ff0055]/40 text-[#ff0055]">{typeLabels[s.request_type] || s.request_type}</span>
              <span className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-slate-500">{s.genre}</span>
              <span className="ml-auto font-mono-tech text-[10px] text-slate-600">{new Date(s.created_at).toLocaleString()}</span>
            </div>
            {s.track_link && (
              <a href={s.track_link} target="_blank" rel="noopener noreferrer" className="font-mono-tech text-[11px] text-[#00ff66] hover:underline break-all">{s.track_link}</a>
            )}
            <p className="text-sm text-slate-300 mt-2 leading-relaxed">{s.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
